import React from 'react';
import { CasePlanDetailCard, CasePlanDetailCardSkeleton } from '@orijinworks/frontend-commons';
import { CasePlanStatusControl } from '../CasePlanStatusControl';
import { StatusChangeConfirmModal } from '../StatusChangeConfirmModal';

export function CasePlanDetailHeader({
  cardProps,
  isSectionsLoading,
  onBack,
  onEditorsClick,
  onExportClick,
  status,
  isEditor,
  isViewOnly,
  onStatusSelect,
  pendingStatus,
  onStatusConfirm,
  onStatusCancel,
}) {
  if (cardProps) {
    return (
      <>
        <CasePlanDetailCard
          {...cardProps}
          onBackClick={onBack}
          onEditorsClick={onEditorsClick}
          onExportClick={onExportClick}
          statusSlot={
            <CasePlanStatusControl
              status={status}
              isEditor={isEditor}
              isViewOnly={isViewOnly}
              onSelect={onStatusSelect}
            />
          }
        />
        <StatusChangeConfirmModal
          open={Boolean(pendingStatus)}
          targetStatus={pendingStatus}
          learnerName={cardProps.learnerName}
          onConfirm={onStatusConfirm}
          onCancel={onStatusCancel}
        />
      </>
    );
  }

  if (isSectionsLoading) {
    return <CasePlanDetailCardSkeleton showBackButton />;
  }

  return null;
}
